/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientDemographic } from '../../models/patient-demographic';

export interface PatientDemographicsGetById$Params {
  patientId: string | null;
  practiceId?: string | null;
}

export function patientDemographicsGetById(http: HttpClient, rootUrl: string, params: PatientDemographicsGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDemographic>> {
  const rb = new RequestBuilder(rootUrl, patientDemographicsGetById.PATH, 'get');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.query('practiceId', params.practiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientDemographic>;
    })
  );
}

patientDemographicsGetById.PATH = '/api/PatientDemographics/{patientId}';
